<template>
  <div class="card">
    <div class="card-body">
      <div class="row align-items-center">
        <div class="col-md-2 col-6">
          <base-input label="วันที่">
            <flat-picker class="form-control datepicker" v-model="startDate" />
          </base-input>
        </div>
        <div class="col-md-2 col-6">
          <base-input label="ถึง">
            <flat-picker class="form-control datepicker" v-model="endDate" />
          </base-input>
        </div>
        <div class="col-md-8 col-12 search">
          <base-button
            type="default"
            @click="submitSearch()"
            :disabled="loading"
          >
            ค้นหา
          </base-button>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-6">
          <redeem-summary-panel :data="summary" />
        </div>
        <div class="col-md-12">
          <redeem-report-panel :data="transactions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPicker from "vue-flatpickr-component";
import RedeemSummaryPanel from "../backend-components/Summary/RedeemSummaryPanel";
import RedeemReportPanel from "../backend-components/Summary/RedeemReportPanel";

import moment from "moment";
import api from "../services";

export default {
  components: {
    flatPicker,
    RedeemSummaryPanel,
    RedeemReportPanel,
  },
  data() {
    return {
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),

      loading: false,
      transactions: [],
      summary: [],
    };
  },
  methods: {
    async submitSearch() {
      this.loading = true;
      try {
        const { transactions, summary } = await api.get("/summary/redeem", {
          params: {
            start: this.startDate,
            end: this.endDate,
          },
        });

        this.transactions = transactions;
        this.summary = summary;
      } catch ({ message }) {
        this.$notify({ type: "danger", message });
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.submitSearch();
  },
};
</script>
